import { render, staticRenderFns } from "./picker_textarea.vue?vue&type=template&id=5f32b154&"
import script from "./picker_textarea.vue?vue&type=script&lang=js&"
export * from "./picker_textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports